import {
  Box,
  ExpandableSection,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { useContext, useState } from "react";
import { DigitalPaymentDocument } from "../../../types/documents";
import { StageContext } from "../../../contexes/OrderIdContext";
import { useExecuteRedrive } from "../../redrive/hooks/useExecuteRedrive";
import {
  AsyncActionButton,
  AsyncStatus,
} from "../../common/AsyncActionButton";

interface DigitalPaymentDocumentViewProps {
  dpd: DigitalPaymentDocument;
  jsonViewProps: any;
}

export function DigitalPaymentDocumentView({
  dpd,
  jsonViewProps,
}: DigitalPaymentDocumentViewProps) {
  const stage = useContext(StageContext);
  const { executeSingleRedrive } = useExecuteRedrive();
  const [redriveStatus, setRedriveStatus] = useState(AsyncStatus.NOT_STARTED);
  const [redriveError, setRedriveError] = useState<string>();

  const { invoiceNumber } = dpd.body.body;

  const handleRedrive = async () => {
    if (!invoiceNumber) {
      setRedriveError("Missing invoice number on this document");
      setRedriveStatus(AsyncStatus.FAILED);
      return;
    }

    setRedriveStatus(AsyncStatus.LOADING);
    try {
      const { data } = await executeSingleRedrive(invoiceNumber, stage);
      if (data?.executionId) {
        setRedriveStatus(AsyncStatus.SUCCESSFUL);
      } else {
        setRedriveError("No execution ID returned");
        setRedriveStatus(AsyncStatus.FAILED);
      }
    } catch (e) {
      const axiosError = e as { response?: { data?: { message?: string } } };
      const message =
        axiosError.response?.data?.message ||
        (e instanceof Error ? e.message : "Redrive failed");
      setRedriveError(message);
      setRedriveStatus(AsyncStatus.FAILED);
    }
  };

  return (
    <SpaceBetween size="l">
      <SpaceBetween direction="horizontal" size="xs">
        <AsyncActionButton
          label="Redrive Payment"
          successLabel="Redrive Submitted"
          failedLabel="Redrive Failed"
          status={redriveStatus}
          onClick={handleRedrive}
          errorMessage={redriveError}
        />
      </SpaceBetween>
      <ExpandableSection
        header={
          <Box variant="h4" margin={{ top: "xxs" }}>
            {dpd.id} (Digital Payment Document)
          </Box>
        }
        variant="container"
      >
        <ReactJson src={dpd.body} {...jsonViewProps} />
      </ExpandableSection>
    </SpaceBetween>
  );
}
